import { ChangeEvent } from 'react';

interface IFormTextarea {
    name: string;
    value: string;
    onChange: (e: ChangeEvent<HTMLTextAreaElement>) => void;
    onBlur: (e: ChangeEvent<HTMLTextAreaElement>) => void;
    error?: string;
    maxLength?: number;
}

const FormTextarea = ({
    name,
    value,
    onChange,
    onBlur,
    error,
    maxLength,
}: IFormTextarea) => (
    <>
        <textarea
            name={name}
            value={value}
            onChange={onChange}
            onBlur={onBlur}
            maxLength={maxLength}
            className={`w-full rounded-lg border-1 p-3 text-base resize-y min-h-180 focus:outline-none focus:ring-offset-0 ${
                error
                    ? 'border-almond-600 ring-3 ring-error-100 ring-opacity-50'
                    : value
                    ? 'border-peppermint-700 ring-2 ring-peppermint-500'
                    : 'border-almond-600'
            }`}
        />
        {error && <p className='text-error-100 text-sm'>{error}</p>}
    </>
);

export default FormTextarea;
